var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      {
        staticClass: "col-12 col-lg-6 form-group form-group__animated",
        class: { "form-group--error": !_vm.validation.name },
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.value.name,
              expression: "value.name",
            },
          ],
          staticClass:
            "form-group__input form-group__input--paddings-classic form-group__animated__input",
          attrs: {
            type: "text",
            name: _vm.name + "-given-name",
            id: _vm.name + "-client_name",
            placeholder: _vm.$t("name", "form_company_data"),
          },
          domProps: { value: _vm.value.name },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.value, "name", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-group__animated__label",
            attrs: { for: _vm.name + "-client_name" },
          },
          [_vm._v(_vm._s(_vm.$t("name", "form_company_data")))]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "col-12 col-lg-6 form-group form-group__animated",
        class: { "form-group--error": !_vm.validation.secondName },
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.value.secondName,
              expression: "value.secondName",
            },
          ],
          staticClass:
            "form-group__input form-group__input--paddings-classic form-group__animated__input",
          attrs: {
            type: "text",
            name: _vm.name + "-family-name",
            id: _vm.name + "-client_second_name",
            placeholder: _vm.$t("last_name", "form_company_data"),
          },
          domProps: { value: _vm.value.secondName },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.value, "secondName", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-group__animated__label",
            attrs: { for: _vm.name + "-client_second_name" },
          },
          [_vm._v(_vm._s(_vm.$t("last_name", "form_company_data")))]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }